// extracted by mini-css-extract-plugin
export default {"heading":"LandscapesTemplate_heading__xEV4b"};